module.exports = __webpack_public_path__ + "img/BN.04d97012.svg";